import {Swiper, SwiperSlide} from "swiper/react";
import "./TimePicker2.scss";
import React, {useEffect} from "react";
import {Carousel} from "react-bootstrap";

const hours = Array.from({length: 24}, (_, i) => i);
const times = [];


const TimePicker = () => {

    hours.map(h => {
        times.push({hour: (h < 10) ? `0${h}` : h, min: "00"});
        times.push({hour: (h < 10) ? `0${h}` : h, min: "30"});
    })
    const handleMinuteChange = (swiper) => {
        // console.log((times.length < ((activeIndex +1) - times.length)) ? 0 : (activeIndex +1) - times.length)
        // setMinute(activeIndex);
        console.log(swiper.key);

    };

    return (
        <div className="timePicker">
            <div className="picker">
                <Swiper
                    slidesPerView={3}
                    direction="vertical"
                    grabCursor
                    centeredSlides
                    loop
                    slideToClickedSlide={true}
                    loopedSlides={48}
                    onActiveIndexChange={handleMinuteChange}>
                    {times.map((time) => {
                        return (
                            <SwiperSlide key={`${time.hour}:${time.min}`}>
                                <div className="d-flex">
                                    <span>{time.min}</span>
                                    <span>:</span>
                                    <span>{time.hour}</span>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </div>

        // <Carousel indicators={false} ={false} controls={false} pause={false} >
        //     {times.map((time) => (
        //         <Carousel.Item>
        //             <div className="d-flex">
        //                 <span>{time.min}</span>
        //                 <span>:</span>
        //                 <span>{time.hour}</span>
        //             </div>
        //         </Carousel.Item>
        //     ))}
        //
        // </Carousel>

    );
};

export default TimePicker;
